import Swal from "sweetalert2";

export default {
  delete(options = {}) {
    return Swal.fire({
      title: "You sure?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "md-button md-success",
      cancelButtonClass: "md-button md-danger",
      confirmButtonText: "Yes, delete it!",
      buttonsStyling: false
    });
  }
};
